module.exports = __webpack_public_path__ + "4ec94c9fa02d0b64c7337087fe2cdff9.svg";